export default {
  en: {
    headers: {
      sidebarHeaderTitle: 'Your decision',
      headerTitle: '{supplierName} / decision request',
      headerError: 'Invalid request',
      clientManagedDescription: "The client answered this assessment on the supplier's behalf.",
    },
    footer: {
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of use',
    },
    content: {
      stats: {
        compliance: 'Compliance',
        exemptions: 'Exemption Applied|Exemptions applied',
        remediations: 'Remediation Pending|Remediations pending',
        risks: 'Open Risk|Open risks',
        noCompliance:
          'This supplier has not yet shared their assessment answers to provide compliance information.',
      },
      evidence: 'Evidence',
      nonCompliantControls: 'Non-compliant controls',
      nonCompliantControlsPlaceholder: 'No non-compliant controls',
      openRisks: 'Open risks',
      risksPlaceholder: 'No open risks',
      risks: {
        riskTitle: 'Risk-{number}',
        open: 'Open',
        uploadTooltip: 'Files attached',
        openedBy: 'Opened by',
        description: 'Description',
        uploadedFiles: 'Uploaded files',
      },
      privateNotes: 'Private notes',
      privateNotesPlaceholder: 'No private notes',
    },
    request: {
      summary: 'Summary',
      recommendation: 'Recommendation',
      approve: 'Approve',
      reject: 'Reject',
      none: 'None',
    },
    notFound: {
      title: 'An error has occurred',
      troubleshooting:
        'Ensure Risk Ledger domains are whitelisted by your IT team. If the problem persists you can contact our customer support team.',
      contactSupport: 'Contact support',
    },
    response: {
      yourDecision: 'Your decision',
      decision:
        'After looking at the information provided, and the summary and recommendation given by {requesterName}, make your decision by selecting one of the options below.',
      approve: 'Approve',
      reject: 'Reject',
      error: 'There was an error submitting your response. Please try again.',
      respondedMessage:
        'Thank you for submitting your response. We have notified {requesterName} about your decision.',
      respondedSubMessage: 'There is no further action to take, you can now close this link.',
      commentPlaceholder: 'Add a comment (optional)',
    },
    incomplete: {
      assessment: 'It looks like this supplier has not yet completed their assessment.',
    },
  },
};
